<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
     _/                                                                                                                    _/
     _/      子画面定義：処理完了画面(STDSDC01C04)                                                                         _/
     _/                                                                                                                    _/
     _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
<template>
  <BaseModal :show="isCompleteShow">
    <div class="popup" style="width: 280px">
      <div class="popup-body">
        <div class="popup-status">
          <img
            src="@/assets/images/TDSCM/pict_done.png"
            alt=""
            width="52"
            height="52"
            class="popup-status-image"
          />
          <p class="popup-status-text">処理が完了しました。</p>
        </div>
        <div class="frm-btn-row">
          <div class="frm-item grow center">
            <button
              tabindex="0"
              class="frm-btn strong large"
              @click="popupClose"
              ref="closeButton"
            >
              閉じる
            </button>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>
<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import BaseModal from "@/components/Base/BaseModal.vue";
export default {
  name: "ProcessingCompleteModal",
  components: { BaseModal },
  computed: {
    ...mapState("businessModule", ["completeFlag"]),
    ...mapGetters("businessModule", ["isCompleteShow"]),
  },
  watch: {
    isCompleteShow: function (newVal) {
      if (newVal) {
        this.$nextTick(function () {
          this.initFocus();
        });
      }
    },
  },
  methods: {
    ...mapMutations("businessModule", ["completeDialogue"]),
    // **********************************************
    // クローズボタンをクリック
    // **********************************************
    popupClose() {
      this.completeDialogue(false);
    },
    // **********************************************
    // 初期フォーカス設定
    // **********************************************
    initFocus() {
      this.$refs.closeButton.focus();
    },
  },
};
</script>
<style></style>
